import { Row, Col, Typography } from "antd";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import ForgottenPasswordForm from "components/forms/ForgottenPassword";
import MetaData from "grandus-lib/components-atomic/MetaData";
import upperFirst from "lodash/upperFirst";
import { useTranslation } from "next-i18next";

const ForgottenPassword = () => {
  const { t } = useTranslation();
  return (
    <div
      className="container guttered"
      style={{ maxWidth: "600px", margin: "40px auto" }}
    >
      <MetaData title={upperFirst(t('user:forgotten password on mobilonline.sk'))} noindex={true} />
      <Row gutter={[20, 16]}>
        <Col xs={24}>
          <Typography.Title level={1}>{upperFirst(t('user:forgotten password'))}</Typography.Title>
          <Typography.Text>

            {`${upperFirst(t("user:did you forget your password"))}? ${upperFirst(t("user:enter your email and we will help you to restore your password"))}.`}
          </Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <ForgottenPasswordForm />
        </Col>
      </Row>
    </div>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'user'])),
    },
  };
};

export default ForgottenPassword;
